export const Bio ={
    roles:
    [
        "Sr.Security Research Analyst",
        "Penetration Tester",
        "Bug Bounty Hunter",
        "Learner",
        "Part Time Gamer"
    ]
}